var React = require('react');

function ArrowRight (props) {
    return React.createElement("svg",props,React.createElement("g",null,React.createElement("path",{"fill":"#bc2626","d":"M265.171,125.577l-80-80c-4.881-4.881-12.797-4.881-17.678,0c-4.882,4.882-4.882,12.796,0,17.678l58.661,58.661H12.5\r\n\t\tc-6.903,0-12.5,5.597-12.5,12.5c0,6.902,5.597,12.5,12.5,12.5h213.654l-58.659,58.661c-4.882,4.882-4.882,12.796,0,17.678\r\n\t\tc2.44,2.439,5.64,3.661,8.839,3.661s6.398-1.222,8.839-3.661l79.998-80C270.053,138.373,270.053,130.459,265.171,125.577z"})));
}

ArrowRight.defaultProps = {"version":"1.1","id":"Capa_1","x":"0px","y":"0px","width":"18px","height":"18px","viewBox":"0 0 268.832 268.832","style":{"enableBackground":"new 0 0 268.832 268.832"},"xmlSpace":"preserve"};

module.exports = ArrowRight;

ArrowRight.default = ArrowRight;
